import { render, staticRenderFns } from "./SelectPerson.vue?vue&type=template&id=23947928&scoped=true"
import script from "./SelectPerson.vue?vue&type=script&lang=js"
export * from "./SelectPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23947928",
  null
  
)

export default component.exports